import { useState } from 'react'

/**
 * Custom hook for managing entity search and selection state
 * Handles entity search query, selection, focus, and isolation
 * 
 * @returns {Object} - Entity search state and setters
 */
export function useEntitySelection() {
  const [entitySearchQuery, setEntitySearchQuery] = useState('')
  const [selectedEntityId, setSelectedEntityId] = useState(null) // Track selected entity from search
  const [focusedEntityId, setFocusedEntityId] = useState(null) // Track entity being highlighted/focused
  const [isolatedEntityId, setIsolatedEntityId] = useState(null) // Track entity to show exclusively (hide all others)

  return {
    entitySearchQuery,
    setEntitySearchQuery,
    selectedEntityId,
    setSelectedEntityId,
    focusedEntityId,
    setFocusedEntityId,
    isolatedEntityId,
    setIsolatedEntityId
  }
}
